module.exports = __webpack_public_path__ + "static/img/avatar-olga-tennison.5a763b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar-olga-tennison.png
// module id = 8n1M
// module chunks = 1